/* istanbul ignore file */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import ProgressSpinner from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import {
  clearSingleDeviceState,
  fetchSingleDevice,
  selectSingleDeviceCrudOperation,
  selectSingleDeviceCrudStatus,
  selectSingleDeviceInitialLoading,
} from '../../../redux/slices/singleDeviceSlice/singleDeviceSlice';
import { CrudType } from '../../../utility/types/CrudType';
import { CrudStatus } from '../../../utility/types/CrudStatus';
import DeviceDetailsLayout from './DeviceDetailsLayout/DeviceDetailsLayout';

function DeviceDetailsPage() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();
  const operation = useSelector(selectSingleDeviceCrudOperation);
  const status = useSelector(selectSingleDeviceCrudStatus);
  const isInitialDeviceDataLoading = useSelector(selectSingleDeviceInitialLoading);

  React.useEffect(() => {
    dispatch(fetchSingleDevice({ deviceId: id, includeArchived: true }))
      .unwrap()
      .catch((error) => {
        if (error && error.status === 400) {
          // eslint-disable-next-line no-console
          console.log('error fetching device redirecting to devices page');
          history.push('/s/devices');
        }
      });

    return () => {
      dispatch(clearSingleDeviceState());
    };
  }, [dispatch, id, history]);

  if (isInitialDeviceDataLoading) {
    return (
      <div className="row d-flex justify-content-center my-5">
        <div>
          <ProgressSpinner />
        </div>
      </div>
    );
  }

  if (operation === CrudType.READ && status === CrudStatus.ERROR) {
    history.push('/s/devices');
    return null;
  }

  return (
    <DeviceDetailsLayout />
  );
}

export default DeviceDetailsPage;
